function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.554 1.902s3.706 3.75 8.851 3.975c3.315.145 7.245-2.76 16.413-2.872 4.906-.06 12.196 2.082 17.999 2.335 3.738.163 10.859-3.982 17.905-3.675 3.03.133 7.281 3.566 12.063 3.775 3.846.168 7.819-2.907 7.819-2.907",
  stroke: "#F5D176",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgImgUnderlineYellow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 8,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODUiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDg1IDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xLjU1Mzg1IDEuOTAxOTFDMS41NTM4NSAxLjkwMTkxIDUuMjU5NjQgNS42NTI1MSAxMC40MDUgNS44NzcxNkMxMy43MjAzIDYuMDIxOTEgMTcuNjQ5NiAzLjExNjM0IDI2LjgxNzYgMy4wMDQ5NUMzMS43MjQxIDIuOTQ1MzQgMzkuMDE0NSA1LjA4NjkgNDQuODE3IDUuMzQwMjRDNDguNTU0OCA1LjUwMzQ0IDU1LjY3NTkgMS4zNTc1NSA2Mi43MjIzIDEuNjY1MkM2NS43NTI4IDEuNzk3NTIgNzAuMDAzNCA1LjIzMTIgNzQuNzg1MyA1LjQzOTk4Qzc4LjYzMDUgNS42MDc4NiA4Mi42MDM1IDIuNTMzMjMgODIuNjAzNSAyLjUzMzIzIiBzdHJva2U9IiNGNUQxNzYiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";
export { SvgImgUnderlineYellow as ReactComponent };